// extracted by mini-css-extract-plugin
export default {"scoreRow":"OrTE28nwjeDHl6SczIdF"};